import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select";

interface SelectOptionProps {
  value: string;
  item: { value: string; label: string }[];
  onValueChange: (value: string) => void;
}

export default function SelectOption({
  value,
  item,
  onValueChange,
}: SelectOptionProps) {
  return (
    <Select defaultValue={value} onValueChange={onValueChange}>
      <SelectTrigger className="">
        <SelectValue placeholder={value || "Select an option"} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {item?.map((element, index) => (
            <SelectItem key={index} value={element.value}>
              {element.label === " " ? (
                <span className="invisible">Text invisble</span>
              ) : (
                element.label
              )}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
